var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInternalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.875 4.71875L15.9375 4.0625C15.25 3.90625 14.5625 4.25 14.3125 4.875L12.9375 8.0625C12.6875 8.625 12.8438 9.3125 13.3438 9.71875L14.5938 10.75C13.7188 12.375 12.3438 13.7188 10.7188 14.625L9.6875 13.375C9.28125 12.875 8.59375 12.7188 8.03125 12.9688L4.84375 14.3125C4.21875 14.5938 3.875 15.2812 4.03125 15.9688L4.6875 18.9062C4.84375 19.5625 5.4375 20 6.09375 20C13.75 20 20 13.8125 20 6.125C20 5.46875 19.5312 4.875 18.875 4.71875ZM6.15625 18.5L5.5 15.6875L8.5625 14.375L10.3125 16.5C13.4062 15.0312 15 13.4375 16.4688 10.3438L14.3438 8.59375L15.6562 5.53125L18.5 6.1875C18.4688 12.9688 12.9375 18.4688 6.15625 18.5Z",
    fill: "#AAAAAA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.04687 5.29297C7.94922 5.39062 7.94922 5.54687 8.04687 5.625L9.47266 6.99219L3.04687 6.99219L4.47266 5.625C4.57031 5.54687 4.57031 5.39062 4.47266 5.29297L4.08203 4.92187C4.00391 4.82422 3.84766 4.82422 3.75 4.92187L1.32812 7.34375C1.23047 7.44141 1.23047 7.57812 1.32812 7.67578L3.75 10.0977C3.84766 10.1953 4.00391 10.1953 4.08203 10.0977L4.47266 9.72656C4.57031 9.62891 4.57031 9.47266 4.47266 9.39453L3.04687 8.02734L9.47266 8.02734L8.04687 9.39453C7.94922 9.47266 7.94922 9.62891 8.04687 9.72656L8.41797 10.0977C8.51562 10.1953 8.67187 10.1953 8.75 10.0977L11.1914 7.67578C11.2891 7.57812 11.2891 7.44141 11.1914 7.34375L8.75 4.92187C8.67187 4.82422 8.51562 4.82422 8.41797 4.92187L8.04687 5.29297Z",
    fill: "#AAAAAA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInternalIcon);
export default __webpack_public_path__ + "static/media/internal_icon.53225c47.svg";
export { ForwardRef as ReactComponent };